module.exports = __webpack_public_path__ + "static/humanitarian_card_img3@2x-9a84c1317fecfa4d6ea0a07e7a351ec8.jpg";